// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const loanTapeSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
  },
  {
    key: 'investorId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'investorId',
  },
  {
    key: 'loanTapeTypeId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'loanTapeTypeId',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['active', 'draft'],
  },
  {
    key: 'activatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'activatedAt',
  },
  {
    key: 'sftpAccessMethod',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'sftpAccessMethod',
    options: ['usernamePassword', 'keys'],
  },
  {
    key: 'sftpSSHPeachPublicKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpSSHPeachPublicKey',
  },
  {
    key: 'sftpHostname',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpHostname',
  },
  {
    key: 'sftpUsername',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpUsername',
  },
  {
    key: 'sftpPassword',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpPassword',
  },
  {
    key: 'sftpCdDir',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpCdDir',
  },
  {
    key: 'encryptionMethod',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'encryptionMethod',
    options: ['', 'GPG'],
  },
  {
    key: 'publicKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'publicKey',
  },
  {
    key: 'customFileName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'customFileName',
  },
  {
    key: 'dateForCustomFileName',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'dateForCustomFileName',
    options: ['', 'reportDate', 'dateOfGeneration'],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(loanTapeSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(loanTapeSchema)
}
